<template>
  <div>
    <img style="width: 100%;" src="../assets/about-banner.png">
    <el-row type="flex" justify="center">
      <el-col :span="24" style="width: 1280px">
        <el-row>
          <img style="width: 100%;" src="../assets/about-content-0.png">
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>
